import React from 'react';
import { useSearchBox } from 'react-instantsearch';

const SearchBox = () => {
    const { query, refine } = useSearchBox();

    return (
        <div className="hero -compact" style={{ backgroundColor: '#D7E4EB', borderTop: '1px solid #000000' }}>
            <div className="container">
                <div className="ais-SearchBox search hero__search">
                    <form className="ais-SearchBox-form" action="" role="search" noValidate>
                        <div className="inputGroup -reverse">
                            <input
                                id="primary-search"
                                type="search"
                                name="query"
                                value={query}
                                placeholder="Enter search terms"
                                className="inputGroup__input ais-SearchBox-input"
                                onChange={(event) => refine(event.currentTarget.value)}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 13) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SearchBox;
